import {
  isTraversalLoadedState,
  type APIViewpointAttributes,
  type ArdoqId,
  type LoadedState,
  type TraversalLoadedState,
} from '@ardoq/api-types';

export type ViewpointsById = Record<ArdoqId, APIViewpointAttributes>;

export const isChangeableTraversalDataset = (
  loadedState: LoadedState
): loadedState is TraversalLoadedState =>
  isTraversalLoadedState(loadedState) && !loadedState.isHidden;

export const getChangeableTraversalDatasets = (
  loadedStates: LoadedState[]
): TraversalLoadedState[] => loadedStates.filter(isChangeableTraversalDataset);

export const getViewpointName = (
  viewpointsById: ViewpointsById,
  { traversalId }: TraversalLoadedState
): string | null =>
  traversalId ? (viewpointsById[traversalId]?.name ?? null) : null;
